import { createReducer, createActions } from 'reduxsauce'

export const INITIAL_STATE = {
  loading: false,
  error: null,
  isAvailable: null,
  hasForbiddenWords: false,
  checkedEmail: null,
  updateLoading: false,
  updateError: null,
  updateSuccess: false,
}

const { Types, Creators } = createActions(
  {
    checkEmailAvailabilityRequest: ['email'],
    checkEmailAvailabilitySuccess: ['isAvailable', 'hasForbiddenWords'],
    checkEmailAvailabilityFailure: ['error'],
    resetEmailAvailability: null,
    updateMailboxRequest: ['email'],
    updateMailboxSuccess: ['email'],
    updateMailboxFailure: ['error'],
    resetUpdateMailbox: null,
  },
  { prefix: 'CHANGE_MAILBOX_' }
)

// Reducers
const checkRequest = (state, { email }) => ({
  ...state,
  loading: true,
  error: null,
  checkedEmail: email,
})

const checkSuccess = (state, { isAvailable, hasForbiddenWords }) => ({
  ...state,
  loading: false,
  error: null,
  isAvailable,
  hasForbiddenWords,
})

const checkFailure = (state, { error }) => ({
  ...state,
  loading: false,
  error,
  isAvailable: null,
  hasForbiddenWords: null,
})

const resetCheck = (state) => ({
  ...state,
  loading: false,
  error: null,
  isAvailable: null,
  hasForbiddenWords: null,
  checkedEmail: null,
})

const updateRequest = (state, { email }) => ({
  ...state,
  updateLoading: true,
  updateError: null,
  updateSuccess: false,
})

const updateSuccess = (state, { email }) => ({
  ...state,
  updateLoading: false,
  updateError: null,
  updateSuccess: true,
})

const updateFailure = (state, { error }) => ({
  ...state,
  updateLoading: false,
  updateError: error,
  updateSuccess: false,
})

const resetUpdate = (state) => ({
  ...state,
  updateLoading: false,
  updateError: null,
  updateSuccess: false,
})

const HANDLERS = {
  [Types.CHECK_EMAIL_AVAILABILITY_REQUEST]: checkRequest,
  [Types.CHECK_EMAIL_AVAILABILITY_SUCCESS]: checkSuccess,
  [Types.CHECK_EMAIL_AVAILABILITY_FAILURE]: checkFailure,
  [Types.RESET_EMAIL_AVAILABILITY]: resetCheck,
  [Types.UPDATE_MAILBOX_REQUEST]: updateRequest,
  [Types.UPDATE_MAILBOX_SUCCESS]: updateSuccess,
  [Types.UPDATE_MAILBOX_FAILURE]: updateFailure,
  [Types.RESET_UPDATE_MAILBOX]: resetUpdate,
}

export const ChangeMailboxTypes = Types
export const ChangeMailboxActionCreators = Creators
export default createReducer(INITIAL_STATE, HANDLERS)
